import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingStockAdjustment';

const PendingStockAdjustment = () => ((orgContainer(InnerComponent)));

export default PendingStockAdjustment;
